var _path, _path2, _path3, _path4;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgMobileSellIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.33333 17.4999C8.79357 17.4999 9.16667 17.1268 9.16667 16.6666C9.16667 16.2063 8.79357 15.8333 8.33333 15.8333C7.8731 15.8333 7.5 16.2063 7.5 16.6666C7.5 17.1268 7.8731 17.4999 8.33333 17.4999Z",
    stroke: "#7647EE",
    strokeWidth: 1.66667,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M15 17.4999C15.4602 17.4999 15.8333 17.1268 15.8333 16.6666C15.8333 16.2063 15.4602 15.8333 15 15.8333C14.5398 15.8333 14.1667 16.2063 14.1667 16.6666C14.1667 17.1268 14.5398 17.4999 15 17.4999Z",
    stroke: "#7647EE",
    strokeWidth: 1.66667,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M1.66666 2.5H4.58332C4.58332 2.5 4.92744 4.02369 5.14793 5C5.58851 6.95082 6.19361 9.63017 6.54862 11.2021C6.72024 11.9619 7.39497 12.5 8.17399 12.5H15.3297C16.1109 12.5 16.7872 11.9574 16.9567 11.1949L18.3333 5",
    stroke: "#7647EE",
    strokeWidth: 1.66667,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M18.3333 5H5.41666",
    stroke: "#7647EE",
    strokeWidth: 1.66667,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMobileSellIcon);
export default __webpack_public_path__ + "static/media/mobileSellIcon.6c0b99c58bfc857eaa421326318b48b2.svg";
export { ForwardRef as ReactComponent };